<template>
    <vx-card id="loader">
        <div class="vx-row header-title ml-3">
            <h3>Модели устройств <vs-button class="ml-5 float-right" color="rgb(250, 130, 80)" @click="createDeviceModel()"
                    type="filled"> Добавить
                    модель </vs-button></h3>

        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/3 mt-1">
                <label>Производители</label>
                <v-select multiple :options="dicts.deviceMakers" label="name" placeholder="Выберите производителей"
                    class="w-full" v-model="form.deviceMakerIds" :reduce="a => a.id">
                </v-select>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input v-model="form.searchPattern" @input="onSearch" autocomplete="off" label="Поиск по названию"
                        placeholder="Введите название..." class="mt-1 w-full" />
                </div>
            </div>

            <div class="vx-col w-1/3 mt-6">
                <div class="vx-col w-full l-1 mb-1">
                    <vs-button class="mt-1" color="success" @click="loadDeviceModels()" type="filled"> Показать </vs-button>
                    <v-select :options="dicts.pageSizes" label="name" placeholder="На странице..."
                        class="ml-1 page-size float-right" v-model="pageSize" :clearable="false"
                        @input="loadDeviceModels()">
                    </v-select>
                </div>
            </div>
        </div>
        <vs-table stripe :data="deviceModels" max-items="10" class="mt-5">
            <template slot="thead">
                <vs-th class="vs-lg-4">
                    Модель
                </vs-th>
                <vs-th class="vs-lg-2">
                    Произв.
                </vs-th>
                <vs-th class="vs-lg-2">
                    Цена
                </vs-th>
                <vs-th class="vs-lg-2">
                    Обновлено
                </vs-th>
                <vs-th class="vs-lg-2">
                    Вкл.
                </vs-th>
                <vs-th class="vs-lg-4">
                    Действия
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :title="tr.id">{{ tr.name }}</vs-td>
                    <vs-td>{{ tr.make }}</vs-td>
                    <vs-td><vs-input v-model="tr.price" autocomplete="off" class="w-full" /></vs-td>
                    <vs-td>{{ tr.updatedAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td>
                        <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="tr.active"
                            @click.native="toggleDeviceModelStatus(tr)"></vs-checkbox>
                    </vs-td>
                    <vs-td>
                        <div class="inline-block cursor-pointer">
                            <router-link :to="{ name: 'devicemodels-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать" position="top" delay=".3s">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Сохранить" position="top" delay=".3s">
                                <feather-icon @click="saveDeviceModel(tr)" icon="SaveIcon"
                                    class="inline-block mr-2 text-success" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить" position="top" delay=".3s">
                                <feather-icon @click="showDeleteModal(tr)" icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="deleteModal" icon="error" title="Удаление">
            <div class="mb-5">Вы действительно хотите удалить {{ selected.name }}?</div>

            <vs-button class="" color="danger" @click="deleteDeviceModel(selected)" type="filled">
                Удалить
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
export default {
    name: 'deviceModels',
    data() {
        return {
            deviceModels: [],
            selected: {},
            dicts: {
                deviceMakers: [],
                pageSizes: [5, 25, 50, 100, 500]
            },
            form: {
                searchPattern: undefined,
                deviceMakerIds: undefined
            },

            page: 1,
            pageSize: 25,
            pagesTotal: 1
        }
    },
    components: {
        SweetModal,
        SweetModalTab,
        vSelect
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([this.axios.get('deviceModels/dicts')])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.deviceMakers = dicts.data.deviceMakers;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки фильтров.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadDeviceModels() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                searchPattern: this.form.searchPattern,
                deviceMakerIds: this.form.deviceMakerIds,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('deviceModels', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    }),
                    this.axios.get('deviceModels/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((deviceModels, count) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.deviceModels = deviceModels.data;
                        this.pagesTotal = count.data > 0 ? Math.ceil(count.data / this.pageSize) : 0;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки моделей устройств.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        onSearch() {
            this.loadDeviceModels();
        },
        saveDeviceModel(tr) {
            var params = {
                id: tr.id,
                price: tr.price
            };

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PATCH',
                url: 'deviceModels/' + tr.id,
                params: params,
                paramsSerializer: (params) => {
                    return qs.stringify(params);
                },
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Успешно обновлено',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении!',
                        color: 'danger'
                    });
                }
            });
        },
        createDeviceModel() {
            this.$router.push('/devicemodels/create')
        },
        showDeleteModal(deviceModel) {
            this.selected = deviceModel;
            this.$refs.deleteModal.open();
        },
        deleteDeviceModel(deviceModel) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'DELETE',
                url: 'deviceModels/' + deviceModel.id,
                errors: this.errors,
                success: () => {
                    this.deviceModels = this.deviceModels.filter(c => c.id != deviceModel.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно удалено",
                        text: "Модель успешно удалена.",
                        color: "success",
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close("#loader > .con-vs-loading");                    
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при удалении! " + err.response.data,
                        color: "danger",
                    });
                }
            })
        },
        toggleDeviceModelStatus(deviceModel) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PATCH',
                url: 'deviceModels/' + deviceModel.id + '/status',
                params: { id: deviceModel.id, isActive: !deviceModel.active },
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");

                    this.$vs.notify({
                        title: "Успешно обновлено",
                        text: "Статус модели устройства успешно обновлен.",
                        color: "success",
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors['']) {
                        const error = err.data.errors[''][0];
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: error,
                            color: "danger",
                        });
                    }

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при обновлении статуса модели устройства!",
                        color: "danger",
                    });
                }
            })
        },
    },
    watch: {
        page: function () {
            this.loadDeviceModels();
        }
    },
    mounted() {
        this.loadDicts();
        this.loadDeviceModels();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Модели устройств';
    }
}
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.vs-pagination-primary {
    margin-top: 10px;
}
</style>